import { AssignmentsFilter } from "../../../../state/models/ParentUiState";
import actionTypes from "../action-types";

export function setAssignmentsFilter(value: AssignmentsFilter) {
  return {
    type: actionTypes.setAssignmentsFilter,
    payload: value
  };
}
